module.exports = {
  Range: 'Phạm vi',
  SorryHavePermissionToInformation: 'Xin lỗi! Bạn không có quyền xem thông tin chi tiết.',
  BusinessInformationSelectionIncorrect: 'Thông tin nghiệp vụ chọn không chính xác.',
  DidOnThePreviousDay: 'Chưa khai báo hải quan ngày hôm trước',
  DeclaredSameDayAsFlight: 'Khai báo hải quan cùng ngày với chuyến bay',
  DeclaredOnTheSameDay: 'Khai báo hải quan trong ngày',
  Other: 'Khác',
  PleaseTheCustomsDeclarationList: 'Vui lòng chọn danh sách khai báo hải quan.',
  LabelPrintingSucceeded: 'In nhãn thành công.',
  ConfirmAudit: 'Xác nhận kiểm tra?',
  PleaseTheMasterBillInformation: 'Vui lòng chọn thông tin vận đơn chính.',
  TheNumberHasBeenInvalidated: 'Số vận đơn chính này đã bị hủy.',
  CancellationSuccessful: 'Hủy thành công.',
  CancellationFail: 'Hủy thất bại.',
  ConfirmBillNumberFromBusiness: 'Xác nhận hủy liên kết số vận đơn chính này với nghiệp vụ trước đó?',
  UnbindingFailed: 'Hủy liên kết thất bại.',
  UnbindingSuccessful: 'Hủy liên kết thành công.',
  MasterBill: 'Vận đơn chính',
  SubBill: 'Vận đơn phụ',
  MasterBillStatus: 'Trạng thái vận đơn chính',
  SubBillStatus: 'Trạng thái vận đơn phụ',
  EnterQueryInformation: 'Vui lòng nhập thông tin tra cứu!',
  ConfirmThis: 'Xác nhận điều này',
  ReceiptNumber: 'Số biên nhận',
  AllFlightMustBeLocking: 'Tất cả đơn hàng trong chuyến bay hiện tại phải được gửi trước khi khóa!',
  OtherDocuments: 'Tài liệu khác',
  CustomsDeclarationDocuments: 'Tài liệu khai báo hải quan',
  PleaseImageYouWantUpload: 'Vui lòng chọn hình ảnh cần tải lên.',
  InvalidReceiptNumber: 'Số biên nhận không hợp lệ!',
  InvalidMasterBillNumber: 'Số vận đơn chính không hợp lệ.',
  NoContactTheAirlineImages: 'Số vận đơn này chưa được ghép chuyến bay, vui lòng liên hệ tuyến bay để ghép chuyến trước khi tải ảnh lên.',
  PleaseFileYouWantDownload: 'Vui lòng chọn tài liệu cần tải xuống.',
  UploadWantToUploadImage: 'Tải lên thành công, có tải ảnh của số tiếp theo không?',
  BulkEditingDestinationPortInformation: 'Sửa hàng loạt thông tin cảng đích',
  OverseasWarehouseNonAmazonWarehouse: 'Kho trung chuyển hải ngoại không phải kho Amazon',
  EstimatedArrivalTime: 'Thời gian dự kiến giao hàng',
  ActualArrivalTime: 'Thời gian giao hàng thực tế',
  NoDataSelected: 'Chưa chọn dữ liệu',
  AllAreInNonState: 'Tất cả bản ghi dữ liệu được chọn đều không ở trạng thái [đang thao tác]',
  TheIsNotSelfConsolidation: 'Loại ghép chuyến của nghiệp vụ này không phải tự ghép, buyer consol hay ủy thác ghép',
  AttachmentTooLarge: 'Nội dung tệp đính kèm quá lớn',
  BusinessStatusChangeLog: 'Nhật ký thay đổi trạng thái nghiệp vụ',
  DomesticWarehouse: 'Kho nội địa',
  OverseasWarehouse: 'Kho nước ngoài',
  LogRecords: 'Bản ghi nhật ký',
  GeneralTrade: 'Thương mại thông thường',
  OperationSuccessful: 'Thao tác thành công',
  PleaseChooseAnAirline: 'Vui lòng chọn tuyến bay!',
  ContainerType: 'Loại container',
  Size: 'Kiểu container',
  LockedPleaseContactSupervisorUnlocking: 'Đã bị khóa, không thể in, vui lòng liên hệ quản lý cấp trên để mở khóa!',
  ProfitAnalysisPrint: 'In phân tích lợi nhuận',
  DoCopyMasterBillInformation: 'Xác nhận sao chép thông tin người gửi/nhận trên vận đơn chính?',
  DeleteSucceeded: 'Xóa thành công!',
  PleaseFormatOfTheLengthwidthheightquantity: 'Vui lòng nhập kích thước đúng định dạng: Dài*Rộng*Cao*Số lượng!',
  GenerationFailed: 'Tạo thất bại!',
  CargoCollectionType: 'Loại hình nhận hàng',
  Commission: 'Ủy thác',
  CustomsClearanceMethod: 'Phương thức thông quan',
  ServiceChannel: 'Kênh dịch vụ',
  ExpectedTimeIntoAmazonWarehouse: 'Thời gian dự kiến nhập kho Amazon',
  ZipCode: 'Mã bưu điện',
  DestinationDeliveryMethod: 'Phương thức giao hàng điểm đến',
  ExpressCompany: 'Công ty chuyển phát',
  CourierNumber: 'Số vận đơn',
  POOriginalOrderNumber: 'PO (Số đơn gốc)',
  EORIBusinessNumber: 'Số EORI doanh nghiệp',
  VATTaxNumber: 'VAT/Mã số thuế',
  VATRegistrationCountry: 'Quốc gia đăng ký VAT',
  VATRegistrationAddress: 'Địa chỉ đăng ký VAT',
  VATCompanyEnglishName: 'Tên công ty bằng tiếng Anh (VAT)',
  EstimatedDeliveryTime: 'Thời gian dự kiến giao hàng',
  ActualDeliveryTime: 'Thời gian giao hàng thực tế',
  WithBattery: 'Có pin',
  WithMagnet: 'Có từ tính',
  Powder: 'Bột',
  Liquid: 'Chất lỏng',
  EstimatedStorageGoodArrivalTime: 'Thời gian dự kiến nhập kho/hàng sẵn sàng',
  RemoteWarehouse: 'Kho xa',
  AirFreight: 'Cước vận chuyển hàng không',
  FeeType: 'Loại chi phí:',
  EstimatedAmount: 'Số tiền ước tính:',
  Equivalent: 'Quy đổi',
  FreightRateLevel: 'Cước vận chuyển:',
  BilledWeight: 'Trọng lượng tính cước:',
  CalculationMethod: 'Phương thức tính:',
  EstimatedTimeCannotBeEmpty: 'Thời gian dự kiến nhập kho/hàng sẵn sàng không được để trống!',
  DestinationCannotBeEmpty: 'Điểm đến không được để trống!',
  DestinationCountryCannotBeEmpty: 'Quốc gia đến không được để trống!',
  ZipCodeCannotBeEmpty: 'Mã bưu điện không được để trống!',
  CannotBeEmpty: 'Không được để trống!',
  InvalidBillNumberCannotBind: 'Số vận đơn chính không hợp lệ, không thể liên kết!',
  PleaseTheConsignorUnitFirst: 'Vui lòng chọn đơn vị ủy thác trước.',
  TheExpensesCanNotMode: 'Phiếu hiện tại có chi phí phân bổ, không thể chuyển chế độ thao tác!',
  DoRefreshTheMAWBInformation: 'Có làm mới thông tin liên quan MAWB không?',
  CourierCompany: 'Công ty chuyển phát',
  ForeignWarehouse: 'Kho nước ngoài',
  CustomsDeclarationMethod: 'Phương thức khai báo hải quan',
  TheSharedExpensesCanSeparate: 'Phiếu hiện tại có chi phí phân bổ, không thể tách!',
  RemoveTicketSuccessfully: 'Gỡ bỏ phiếu thành công!',
  AttachmentDescription: 'Phụ lục giải thích:',
  AirlineCannotBeEmpty: 'Hãng hàng không không được để trống',
  AddNew: 'Thêm mới',
  NoItemDetailsSelected: 'Chưa chọn chi tiết hàng hóa!',
  SellingPriceCalculationCompleted: 'Tính toán giá bán hoàn tất',
  PleaseSelectWarehouseEntryData: 'Vui lòng chọn dữ liệu nhập kho!',
  DeletedSuccessfully: 'Xóa thành công!',
  PleaseAPieceOfData: 'Vui lòng chọn một dữ liệu!',
  CustomsClearanceTracking: 'Theo dõi khai báo hải quan',
  CustomsClearanceQuantity: 'Số lượng kiện khai báo',
  CustomsClearanceWeight: 'Trọng lượng khai báo',
  CustomsClearanceDate: 'Ngày khai báo',
  CustomsClearanceInformation: 'Thông tin khai báo',
  MultipleCustomsDeclarations: 'Nhiều tờ khai hải quan',
  WhetherApplyForCommercialInspection: 'Có kiểm dịch không',
  WhetherToCheck: 'Có kiểm tra không',
  PleaseSelectCustomsClearanceInformation: 'Vui lòng chọn thông tin khai báo.',
  TheBeEqualToBusiness: 'Tổng số lượng và trọng lượng khai báo phải bằng với thực tế nghiệp vụ.',
  NextLegEntry: 'Nhập thông tin chặng tiếp theo',
  ActualFlight: 'Chuyến bay thực tế:',
  NextLegInformation: 'Thông tin chặng tiếp theo:',
  ActualFlightCannotBeEmpty: 'Chuyến bay thực tế không được để trống.',
  ActualDepartureDate: 'Ngày khởi hành thực tế.',
  NextInformationCannotBeEmpty: 'Thông tin chặng tiếp theo không được để trống.',
  BatchModificationOfReportStatus: 'Sửa trạng thái báo cáo hàng loạt',
  CustomsClearanceStatus: 'Trạng thái khai báo:',
  PleaseSelectCustomsClearanceStatus: 'Vui lòng chọn trạng thái khai báo.',
  SelectAirPort: 'Chọn cảng hàng không',
  PleaseSelectAPort: 'Vui lòng chọn cảng!',
  FlightSelection: 'Lựa chọn chuyến bay',
  Monday: 'Thứ hai',
  Tuesday: 'Thứ ba',
  Wednesday: 'Thứ tư',
  Thursday: 'Thứ năm',
  Friday: 'Thứ sáu',
  Saturday: 'Thứ bảy',
  Sunday: 'Chủ nhật',
  FlightSchedule: 'Lịch bay',
  Weekly: 'Hàng tuần',
  PleaseSelectAFlight: 'Vui lòng chọn một chuyến bay.',
  PleaseEnterACode: 'Vui lòng nhập mã!',
  CodeExistsPleaseReEnter: 'Mã đã tồn tại, vui lòng nhập lại!',
  PleaseEnterAName: 'Vui lòng nhập tên!',
  PleaseAddARegionalPort: 'Vui lòng thêm cảng khu vực!',
  AreYouWantToDelete: 'Xác nhận xóa?',
  PleaseTheDepartureRegionCode: 'Vui lòng nhập mã khu vực xuất phát!',
  PleaseTheDestinationRegionCode: 'Vui lòng nhập mã khu vực đích!',
  DepartureRegionCodeCannotSame: 'Mã khu vực xuất phát và mã khu vực đích không được giống nhau!',
  WeeklySchedule: 'Lịch trình',
  PleaseEffectiveDateStartTime: 'Vui lòng chọn thời gian bắt đầu hiệu lực!',
  PleaseSelectTheSchedule: 'Vui lòng chọn lịch trình!',
  PleaseEnterTheTransshipmentPort: 'Vui lòng nhập cảng chuyển tải.',
  AreWantToDeleteRoute: 'Xác nhận xóa tuyến đường này?',
  GenerateFlight: 'Tạo chuyến bay',
  PleaseEnterAFlightNumber: 'Vui lòng nhập số hiệu chuyến bay!',
  PleaseEnterAnAirline: 'Vui lòng nhập hãng hàng không!',
  PleaseEnterTheDeparturePort: 'Vui lòng nhập cảng khởi hành!',
  PleaseEnterTheDestinationPort: 'Vui lòng nhập cảng đến!',
  PleaseDepartureTimeForWeek: 'Vui lòng nhập tuần',
  AreWantToDeleteFlight: 'Xác nhận xóa chuyến bay này?',
  TheWantToDeleteRegenerate: 'Đã tạo chuyến bay, có xóa thông tin cũ để tạo lại không?',
  GenerationSuccessful: 'Tạo thành công.',
  AtBookingNatureAirportEntered: 'Phải nhập ít nhất một trong các mục: tuyến bay, hãng hàng không, tính chất đặt chỗ, cảng hàng không, bán hàng!',
  ResponsibilitiesAssignedNoDeletionAllowed: 'Chức trách đã được phân công, không được phép xóa!',
  AreToDeleteThisRecord: 'Xác nhận xóa bản ghi này?',
  TheTheAirlineIsModify: 'Mã ba chữ cái của hãng hàng không bị sai, vui lòng sửa lại!',
  PleaseSelectAnAirline: 'Vui lòng chọn hãng hàng không!',
  PleaseSelectTheExpirationDate: 'Vui lòng chọn ngày hết hạn!',
  PleaseStartingMasterBillNumber: 'Vui lòng nhập số vận đơn chính bắt đầu!',
  TheLegalThereIsAirline: 'Số bắt đầu không hợp lệ, không có hãng hàng không phù hợp!',
  TheNumberIsNotLegal: 'Số vận đơn chính không hợp lệ!',
  PleaseTheDateOfPossession: 'Vui lòng chọn ngày nhận!',
  TheMasterBillMayExist: 'Số vận đơn chính trong đoạn số hiện tại có thể đã tồn tại!',
  ConfirmDeleteTheMasterBill: 'Xác nhận xóa vận đơn chính?',
  CancelSubmission: 'Hủy nộp',
  SaveSuccessfully: 'Lưu thành công!',
  SaveSuccess: 'Lưu thành công',
  PleaseTheWarehouseEntryNumber: 'Vui lòng nhập số nhập kho!',
  PleaseWeightOfTheSeal: 'Vui lòng chọn trọng lượng niêm phong!',
  PleaseEnterTheWarehouseName: 'Vui lòng nhập tên kho hàng!',
  ReviewSucceeded: 'Duyệt thành công!',
  LockedContactAHigherUnlock: 'Đã bị khóa, không thể in, vui lòng liên hệ quản lý cấp trên để mở khóa!',
  PleasePortOfDepartureDestination: 'Vui lòng nhập một cảng khởi hành hoặc cảng đến!',
  SaveFileFormatIsIncorrect: 'Lưu thất bại, định dạng file Excel không đúng!',
  SuccessfullyImported: 'Nhập thành công',
  PiecesOfData: 'dòng dữ liệu!',
  SaveFailed: 'Lưu thất bại!',
  PleaseThePortOfDeparture: 'Vui lòng nhập cảng khởi hành!',
  CompleteOperationRequirements: 'Hoàn thành yêu cầu thao tác',
  PleaseSelectTheCompletionTime: 'Vui lòng chọn thời gian hoàn thành.',
  CurrentlySelected: '(Lựa chọn hiện tại)',
  CurrentPage: '(Trang hiện tại)',
  CompletionStatus: 'Trạng thái hoàn thành',
  Completed: 'Đã hoàn thành',
  Uncompleted: 'Chưa hoàn thành',
  OperationRequirementDescription: 'Hướng dẫn yêu cầu thao tác',
  CurrentSelectionIncludesCompletedStatus: 'Lựa chọn hiện tại bao gồm trạng thái đã hoàn thành.',
  OperationRequirementTracking: 'Theo dõi yêu cầu thao tác',
  ConfirmCancellation0: 'Xác nhận hủy số [{0}]?',
  DeDepartureTime: 'thời gian cất cánh.',
  AERequiredChecksum: 'Số bắt đầu của vận đơn chính hoặc thêm hàng loạt, bắt buộc chọn một',
  FlightInformation: 'Thông tin chuyến bay',
  TrackingDetails: 'Chi tiết theo dõi hành trình',
  StartingStation: 'Ga xuất phát',
  DestinationStation: 'Ga đích',
  FlightNumber: 'Số hiệu chuyến bay',
  DepartureTime: 'Thời gian khởi hành',
  ArrivalTime: 'Thời gian đến',
  Pieces: 'Số kiện',
  Weight: 'Trọng lượng',
  Time: 'Thời gian',
  Status: 'Trạng thái',
  Airport: 'Sân bay',
  Unknown: 'Không xác định',
  BKD: 'Đặt chỗ',
  RCS: 'Nhập kho',
  MAN: 'Xếp tải',
  DEP: 'Cất cánh',
  ARR: 'Đến nơi',
  AWD: 'Nhận đơn',
  RCF: 'Dỡ hàng',
  NFD: 'Thông báo hàng đến',
  DLV: 'Nhận hàng',
  TAR: 'Đến trung chuyển',
  TDE: 'Cất cánh trung chuyển',
  TRF: 'Dỡ hàng trung chuyển',
  RWB: 'Nhận đơn',
  CUS: 'Thông quan',
  AeMawbChargeWeight: 'Trọng lượng tính cước lập vận đơn hàng không',
  AeBookingChargeWeight: 'Trọng lượng tính cước đặt chỗ hàng không',
  MawbChargeWeight: 'Trọng lượng tính cước lập vận đơn',
  BookingChargeWeight: 'Trọng lượng tính cước đặt chỗ',
  ImportBoardInstallInfo: 'Nhập PLT',
  PleaseImportCorrectTemplate: 'Vui lòng nhập thông tin theo mẫu chính xác',
  ClickDownloadTemplate: 'Có thể tải mẫu bằng cách nhấp vào',
  AsyncUploadLogView: 'Thao tác này là bất đồng bộ, bạn có thể xem kết quả nhập trong "Lưu trữ tệp -> Nhật ký tải lên"',
  ServiceInformation: 'Thông tin dịch vụ',
  ControlDisplayConfiguration: 'Cấu hình hiển thị điều khiển',
  WovenFabricorder: 'Vải dệt (đơn hàng)',
  BookingForCargobooking: 'Đặt chỗ cho hàng hóa (đặt chỗ)',
  ItemMaoTiForwardWarehouseActual: 'Loại hàng毛 (kho tiền chế (thực tế))',
  ItemMaoTiOrderProcessing: 'Loại毛 thể (xử lý đơn hàng)'
}
